"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SBTypesParsers = void 0;
const postcss_value_parser_1 = __importDefault(require("postcss-value-parser"));
const pseudo_states_1 = require("./pseudo-states");
const selector_1 = require("./helpers/selector");
const mixin_1 = require("./helpers/mixin");
const value_1 = require("./helpers/value");
const features_1 = require("./features");
exports.SBTypesParsers = {
    '-st-root'(value) {
        return value === 'false' ? false : true;
    },
    '-st-global'(decl, diagnostics) {
        const selector = (0, selector_1.parseSelectorWithCache)(decl.value.replace(/^['"]/, '').replace(/['"]$/, ''), { clone: true });
        if (!selector[0]) {
            diagnostics.error(decl, features_1.CSSClass.diagnostics.EMPTY_ST_GLOBAL());
            return;
        }
        else if (selector.length > 1) {
            diagnostics.error(decl, features_1.CSSClass.diagnostics.UNSUPPORTED_MULTI_SELECTORS_ST_GLOBAL());
        }
        return selector[0].nodes;
    },
    '-st-states'(value, decl, diagnostics) {
        if (!value) {
            return {};
        }
        return (0, pseudo_states_1.processPseudoStates)(value, decl, diagnostics);
    },
    '-st-extends'(value) {
        const ast = (0, postcss_value_parser_1.default)(value);
        const types = [];
        ast.walk((node) => {
            if (node.type === 'function') {
                const args = (0, value_1.getNamedArgs)(node);
                types.push({
                    symbolName: node.value,
                    args,
                });
                return false;
            }
            else if (node.type === 'word') {
                types.push({
                    symbolName: node.value,
                    args: null,
                });
            }
            return undefined;
        }, false);
        return {
            ast,
            types,
        };
    },
    '-st-mixin': mixin_1.parseStMixin,
    '-st-partial-mixin': mixin_1.parseStPartialMixin,
};
//# sourceMappingURL=stylable-value-parsers.js.map